const dates = [
  { date: '11 April', day: 'Saturday', location: 'Arilova',      time: '4:00 PM', num: '01', mapUrl: 'https://maps.app.goo.gl/5SeBP2c5JtbELpTMA' },
  { date: '18 April', day: 'Saturday', location: 'Madhurawada',   time: '4:00 PM', num: '02', mapUrl: 'https://maps.app.goo.gl/o1wUS4msXwoj9RDy9' },
  { date: '25 April', day: 'Saturday', location: 'Yendada',       time: '4:00 PM', num: '03', mapUrl: 'https://maps.app.goo.gl/UrVabfG6nACTBy4m7' },
];

const ConferenceDates = () => {
  return (
    <section
      id="conference-dates"
      className="relative py-28 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #080808 0%, #0e0e0e 100%)' }}
    >
      {/* Top glow bar */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.5), transparent)' }}
      />
      {/* Bottom glow bar */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.25), transparent)' }}
      />
      {/* Large ambient glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: '600px',
          height: '400px',
          background: 'radial-gradient(ellipse, rgba(212,168,66,0.05) 0%, transparent 70%)',
        }}
      />

      <div className="max-w-2xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 mb-7 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
            style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.35)', color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            <span>✦</span> Conference Schedule
          </div>
          <h2
            className="font-black uppercase mb-2"
            style={{
              fontFamily: "'Glacial Indifference', sans-serif",
              fontSize: 'clamp(2rem, 7vw, 3.2rem)',
              color: '#FFFFFF',
              textShadow: '0 0 40px rgba(212,168,66,0.2)',
            }}
          >
            Three Saturdays.
          </h2>
          <h3
            className="font-bold uppercase tracking-widest"
            style={{ fontFamily: "'Glacial Indifference', sans-serif", fontSize: 'clamp(1rem, 3.5vw, 1.5rem)', color: '#D4A842' }}
          >
            Three Locations. One Cry.
          </h3>
        </div>

        {/* Date cards */}
        <div className="flex flex-col gap-4">
          {dates.map((item, idx) => (
            <div
              key={item.location}
              className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.015] cursor-default"
              style={{ border: '1px solid rgba(212,168,66,0.22)' }}
            >
              {/* Card bg */}
              <div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(135deg, rgba(212,168,66,0.1) 0%, rgba(${idx === 0 ? '20,15,5' : '12,12,12'},0.97) 100%)`,
                }}
              />
              {/* Right-side stage spotlight glow */}
              <div
                className="absolute right-0 top-0 bottom-0 pointer-events-none"
                style={{
                  width: '200px',
                  background: 'radial-gradient(ellipse at right center, rgba(212,168,66,0.08) 0%, transparent 70%)',
                }}
              />
              {/* Left accent bar */}
              <div
                className="absolute left-0 top-4 bottom-4 w-0.5 rounded-full"
                style={{ background: 'linear-gradient(to bottom, transparent, rgba(212,168,66,0.8), transparent)' }}
              />

              <div className="relative flex items-center gap-5 p-6 md:p-7">
                {/* Ghost number */}
                <div
                  className="text-6xl font-black leading-none flex-shrink-0 select-none"
                  style={{
                    fontFamily: "'Blinker', sans-serif",
                    color: 'rgba(212,168,66,0.12)',
                    lineHeight: 1,
                  }}
                >
                  {item.num}
                </div>

                {/* Details */}
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-baseline gap-3 mb-1.5">
                    <span
                      className="font-black"
                      style={{ fontFamily: "'Blinker', sans-serif", fontSize: 'clamp(1.4rem, 5vw, 1.9rem)', color: '#FFFFFF' }}
                    >
                      {item.date}
                    </span>
                    <span className="text-xs font-medium uppercase tracking-widest" style={{ color: '#666', fontFamily: "'Glacial Indifference', sans-serif" }}>
                      {item.day}
                    </span>
                  </div>
                  <a
                    href={item.mapUrl}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="inline-flex flex-col mb-4 cursor-pointer group/map"
                    style={{ textDecoration: 'none' }}
                  >
                    <span
                      className="inline-flex items-center gap-1.5 font-bold transition-opacity group-hover/map:opacity-80"
                      style={{ fontFamily: "'Glacial Indifference', sans-serif", fontSize: 'clamp(1.1rem, 3.5vw, 1.4rem)', color: '#D4A842', textShadow: '0 0 20px rgba(212,168,66,0.4)' }}
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-map-pin-line text-xs" />
                      </div>
                      {item.location}
                    </span>
                    <span
                      className="inline-flex items-center gap-1 mt-0.5 ml-5 transition-all group-hover/map:gap-2 group-hover/map:opacity-100 opacity-70"
                      style={{ fontFamily: "'Glacial Indifference', sans-serif", fontSize: '0.7rem', color: '#D4A842', letterSpacing: '0.06em', fontWeight: 600, textTransform: 'uppercase' }}
                    >
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-xs" />
                      </div>
                      Tap for Directions
                    </span>
                  </a>
                  <div className="flex flex-wrap gap-2">
                    <div
                      className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-semibold"
                      style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.25)', color: '#F0C040', fontFamily: "'Blinker', sans-serif" }}
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-time-line text-xs" />
                      </div>
                      {item.time}
                    </div>
                    <div
                      className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-semibold"
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.09)', color: '#888', fontFamily: "'Glacial Indifference', sans-serif" }}
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-bus-2-line text-xs" />
                      </div>
                      Transport Available
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact banner */}
        <div
          className="mt-8 rounded-2xl p-6 relative overflow-hidden flex flex-col items-center text-center gap-4"
          style={{
            background: 'linear-gradient(135deg, rgba(212,168,66,0.12) 0%, rgba(212,168,66,0.04) 100%)',
            border: '1px solid rgba(212,168,66,0.32)',
          }}
        >
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.08) 0%, transparent 60%)' }}
          />
          <div className="relative">
            <p
              className="text-xs font-black tracking-widest uppercase mb-1.5"
              style={{ color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
            >
              Need Transport Support?
            </p>
            <p className="text-sm" style={{ color: '#888', fontFamily: "'Glacial Indifference', sans-serif" }}>
              Don&apos;t worry about getting here — just reach out and we&apos;ll take care of the rest.
            </p>
          </div>
          <a
            href="https://wa.me/919502891444"
            target="_blank"
            rel="nofollow noreferrer"
            className="relative whitespace-nowrap flex items-center justify-center gap-2 w-full px-7 py-3.5 rounded-full font-black text-sm text-black cursor-pointer transition-transform hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #F5D060, #D4A842)',
              fontFamily: "'Glacial Indifference', sans-serif",
              boxShadow: '0 0 22px rgba(212,168,66,0.5)',
            }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-fill text-sm" />
            </div>
            Message Us — We&apos;ll Get You There
          </a>
        </div>
      </div>
    </section>
  );
};

export default ConferenceDates;
